// extracted by mini-css-extract-plugin
module.exports = {"title":"EditItem_title__3vXXx","row":"EditItem_row__1lzK5","btns":"EditItem_btns__2-Zwj"};